import React from 'react';
import {sizes, svgs} from '../../../constants';
import Icon from '../../icon/Icon';
import Message from '../../message/Message';
import Link from '../../link/Link';
import Asset, {AssetProps} from './Asset';
import styles from './DefaultToastItem.pcss';

type ToastAction = (toastId: number) => void;

interface Props extends AssetProps {
    className?: string;
    dismissToast: ToastAction;
    id: number;
    text: string;
    messages: any[];
}

const DefaultToastItem = ({avatar, dismissToast, icon, id, isError, text, messages}: Props) => {
    return (
        <>
            <div className={styles.content}>
                <Asset avatar={avatar} icon={icon} isError={isError} />
                <div className={styles.messages}>
                    {text}
                    {messages &&
                        messages.map(message => {
                            const {code, args, to} = message;
                            return to ? (
                                <Link id={code} to={to}>
                                    <Message code={code} args={args} />
                                </Link>
                            ) : (
                                <Message id={code} code={code} args={args} />
                            );
                        })}
                </div>
            </div>
            <button className={styles.closeButton} onClick={() => dismissToast(id)}>
                <Icon icon={svgs.CLOSE} size={sizes.XXXSMALL} />
            </button>
        </>
    );
};

export default DefaultToastItem;
